export const FALLBACK_CONFIG = {
  phone_display: "(877) 833-1907",
  phone_href: "+18778331907",
  email_quotes: "quotes@1907insurance.com",
  email_agent: "michael@1907insurance.com",
  npn: "21419333",
  states_served_text: "Serving clients in 19 states",
  licensed_states: ["[STATE LIST PENDING — confirm all 19 licensed states before launch]"],
  business_hours: "Monday–Friday, 9:00 AM–6:00 PM CT (placeholder — confirm hours)",
  response_time: "We typically respond within one business day. (placeholder)",
  announcement: "Personal guidance from an independent licensed life insurance agent.",
  hero_headline: "Life Insurance Made Personal and Simple",
  scheduling_enabled: true,
  carriers: [],
  social_links: [],
  business_address: "[BUSINESS ADDRESS PENDING — add a mailing address before launch]",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Final Expense", to: "/final-expense" },
  { label: "Term Life", to: "/term-life" },
  { label: "About", to: "/about" },
  { label: "Carriers", to: "/carriers" },
  { label: "FAQs", to: "/faqs" },
  { label: "Contact", to: "/contact" },
];

export const TRUST_CARDS = [
  {
    title: "Independent Guidance",
    text: "Explore options from multiple insurance companies instead of being limited to a single carrier.",
    icon: "Compass",
  },
  {
    title: "Coverage for Real-Life Needs",
    text: "Find protection for final expenses, family income, debts, or other responsibilities.",
    icon: "ShieldCheck",
  },
  {
    title: "Straightforward Explanations",
    text: "Understand the policy, premium, benefit, and important limitations before making a decision.",
    icon: "FileText",
  },
  {
    title: "Personal Service",
    text: "Work directly with a licensed agent who can help before, during, and after the application.",
    icon: "Handshake",
  },
];

export const STEPS = [
  {
    n: "01",
    title: "Tell Us What You Need",
    text: "Complete a short form or call Michael to discuss your goals.",
  },
  {
    n: "02",
    title: "Review Your Options",
    text: "Michael helps compare available policies based on your age, health, state, and budget.",
  },
  {
    n: "03",
    title: "Apply With Confidence",
    text: "Choose the option that fits your needs and receive guidance through the application process.",
  },
  {
    n: "04",
    title: "Ongoing Service",
    text: "Contact 1907 Insurance Group when you have questions about your coverage.",
  },
];

export const PRODUCTS = [
  {
    title: "Final Expense Insurance",
    points: [
      "Permanent whole life coverage",
      "Often used for funeral costs and final bills",
      "Commonly designed for adults in later stages of life",
      "Coverage and eligibility vary by carrier",
    ],
    link: "/final-expense",
  },
  {
    title: "Term Life Insurance",
    points: [
      "Coverage for a selected period of time",
      "May provide larger death benefits at an initially lower premium",
      "Often used for family income, debts, or children's needs",
      "Coverage ends or changes after the selected term unless renewed or converted according to the policy",
    ],
    link: "/term-life",
  },
  {
    title: "Mortgage & Family Protection",
    points: [
      "Intended to help loved ones handle a mortgage, debts, or income loss",
      "Can help with other ongoing financial responsibilities",
      "Policy selection should be based on your family's overall needs",
    ],
    link: "/quote",
  },
];

export const FINAL_EXPENSE_USES = [
  "Funeral and burial expenses",
  "Cremation costs",
  "Medical bills",
  "Credit card balances",
  "Small debts",
  "Other final obligations",
  "Money left to loved ones",
];

export const FINAL_EXPENSE_SUMMARY = [
  "Generally designed for older adults",
  "Permanent coverage when premiums are paid and policy requirements are met",
  "Level premiums on many products",
  "Coverage amounts vary by carrier",
  "Simplified underwriting may be available",
  "Some policies include a graded or modified benefit period",
];

export const FAQ_HOME = [
  {
    q: "What is final expense life insurance?",
    a: "Final expense insurance is generally a small whole life policy designed to help your beneficiaries pay for funeral costs, medical bills, and other end-of-life expenses. Coverage stays in force for life as long as premiums are paid and policy requirements are met.",
  },
  {
    q: "How much final expense coverage might I need?",
    a: "It depends on the expenses you want covered — a funeral, cremation, remaining bills, or a gift to family. Michael can help you estimate a reasonable amount based on your goals and budget.",
  },
  {
    q: "Can I qualify if I have health problems?",
    a: "Many people with health concerns can still find coverage. Carriers evaluate health differently, and some products use simplified underwriting with only a few health questions. Eligibility always depends on the specific insurer and policy.",
  },
  {
    q: "Will I need a medical exam?",
    a: "Many final expense policies do not require a medical exam — they use health questions instead. Some term policies may require an exam, depending on the carrier, amount, and your age.",
  },
  {
    q: "What is a graded death benefit?",
    a: "Some policies pay a reduced benefit if death occurs during the first two or three years (often returning premiums paid plus interest), then pay the full benefit afterward. The exact terms depend on the policy.",
  },
  {
    q: "How is an independent agent different from a captive agent?",
    a: "A captive agent represents one insurance company. An independent agent like Michael works with multiple carriers and can compare available options to help find a fit for your situation.",
  },
  {
    q: "Does requesting a quote cost anything?",
    a: "No. Requesting a quote or speaking with Michael is free, and there is no obligation to buy anything.",
  },
  {
    q: "How quickly can coverage begin?",
    a: "It varies by carrier and product. Some simplified-issue policies can be approved quickly, while others take longer. Coverage is never in force until the insurance company approves the application and all policy requirements are satisfied.",
  },
  {
    q: "Can my premium increase?",
    a: "Many final expense whole life policies have level premiums that are designed not to increase. Term policies may increase if renewed after the initial term. The policy itself controls — review it carefully.",
  },
  {
    q: "What information is needed to apply?",
    a: "Typically your basic personal information, health questions, and beneficiary details. You will never be asked for sensitive information through this website's quote form.",
  },
];

export const FAQ_PAGE = [
  {
    category: "Getting Started",
    items: [
      { q: "How do I get started?", a: "Request a quote online, schedule a call, or simply call (877) 833-1907. Michael will ask a few questions about what you want your coverage to accomplish and go from there." },
      { q: "Does it cost anything to talk with an agent?", a: "No. There is no fee to request a quote, ask questions, or speak with Michael. Agents are compensated by the insurance company if you choose to purchase a policy." },
      { q: "Am I obligated to buy anything after requesting a quote?", a: "Absolutely not. A quote is simply information. You decide what, if anything, you want to do with it." },
      { q: "Can an adult child help a parent with this process?", a: "Yes. Family members often help gather information and join conversations. The person applying for coverage will need to participate in and sign the application." },
    ],
  },
  {
    category: "Final Expense",
    items: [
      { q: "What is final expense life insurance?", a: "It is generally a small whole life policy intended to help beneficiaries pay funeral, burial, cremation, medical, and other end-of-life costs. It provides permanent coverage when premiums are paid and policy requirements are met." },
      { q: "How much coverage can I get?", a: "Final expense policies are typically smaller than traditional life insurance — often in the range of a few thousand dollars up to around $25,000–$50,000 depending on the carrier. Available amounts vary by company, age, and state." },
      { q: "What is the difference between level and graded benefits?", a: "A level benefit pays the full amount from day one (subject to policy terms). A graded or modified benefit pays a reduced amount — often a return of premiums plus interest — if death occurs in the first two or three years, then the full amount afterward." },
      { q: "What can the benefit be used for?", a: "Your beneficiary receives the money and decides how to use it — funeral costs, medical bills, debts, or anything else. It is not restricted to funeral expenses." },
      { q: "What happens if I stop paying premiums?", a: "The policy can lapse and coverage would end. Some policies build cash value that may provide options, depending on the contract. Ask about this before choosing a policy." },
    ],
  },
  {
    category: "Term Life",
    items: [
      { q: "What is term life insurance?", a: "Term life provides coverage for a selected period — commonly 10, 15, 20, or 30 years. If you pass away during the term, your beneficiary receives the death benefit. If the term ends, coverage ends unless renewed or converted under the policy's terms." },
      { q: "Who is term life a good fit for?", a: "People who need larger amounts of protection for a defined period — for example, to replace income, cover a mortgage, or provide for children while they grow up." },
      { q: "What happens when my term ends?", a: "Coverage typically ends, though some policies allow renewal (usually at a much higher premium) or conversion to a permanent policy within a specified window. Review your policy's options before the term expires." },
      { q: "Does term life build cash value?", a: "Generally no. Term life is pure protection, which is why it usually costs less per dollar of coverage than permanent insurance." },
    ],
  },
  {
    category: "Health & Underwriting",
    items: [
      { q: "Can I get coverage with health problems?", a: "Often, yes. Different carriers view conditions differently, and some products ask only a handful of health questions. Michael can help identify which options may be available for your situation. Approval is never guaranteed and depends on the insurer." },
      { q: "Will I need a medical exam?", a: "Many final expense and some term policies use simplified underwriting with health questions only. Larger term policies are more likely to require an exam. It depends on the product, amount, age, and carrier." },
      { q: "Why do truthful answers matter on an application?", a: "Applications are legal documents. Incorrect or incomplete answers can give the insurer grounds to deny a claim or rescind the policy, especially during the contestability period (usually the first two years)." },
      { q: "What is the contestability period?", a: "A period — typically two years after a policy starts — during which the insurer can investigate and potentially deny a claim if the application contained material misstatements. Policies also generally include a suicide provision during a similar initial period. Terms vary by policy and state." },
    ],
  },
  {
    category: "Premiums & Payments",
    items: [
      { q: "Can my premium go up?", a: "Many final expense whole life policies have level premiums designed to stay the same. Term premiums are typically level during the term but can rise substantially at renewal. Your policy contract controls — read it and ask questions." },
      { q: "How can I pay my premiums?", a: "Most carriers accept monthly bank drafts, and many offer quarterly, semi-annual, or annual options. Payment methods vary by company." },
      { q: "What if I miss a payment?", a: "Policies usually include a grace period (often 30–31 days). If premiums remain unpaid past the grace period, the policy can lapse. Contact your carrier or agent promptly if you expect difficulty making a payment." },
    ],
  },
  {
    category: "Beneficiaries & Claims",
    items: [
      { q: "Who can I name as my beneficiary?", a: "Typically a spouse, child, other family member, trust, or anyone with an insurable interest. You can usually name more than one beneficiary and change them later." },
      { q: "How does my family file a claim?", a: "The beneficiary contacts the insurance company, submits a claim form and a certified death certificate. Michael and 1907 Insurance Group can help your family understand where to start." },
      { q: "How long do claims take?", a: "It varies by carrier and circumstances. Claims during the contestability period or with incomplete documentation may take longer. The insurer handling the policy controls the timeline." },
    ],
  },
  {
    category: "Working With 1907 Insurance Group",
    items: [
      { q: "Is 1907 Insurance Group an insurance company?", a: "No. 1907 Insurance Group is an independent insurance agency. Policies are issued by the insurance companies Michael is appointed with, and each policy's terms come from that carrier." },
      { q: "Which states are you licensed in?", a: "1907 Insurance Group serves clients in 19 states. Contact Michael to confirm availability in your state — carrier and product availability varies by state." },
      { q: "Will my information be kept private?", a: "Yes. Information you submit is used only to help with your insurance request. See the Privacy Policy for details, including how to request deletion of your information." },
      { q: "What if I already have life insurance?", a: "That's fine. Michael can review what you have, explain how it works, and help you decide whether additional or different coverage makes sense. Never cancel an existing policy before new coverage is approved and in force." },
    ],
  },
];

export const TERM_COMPARISON = [
  { feature: "Coverage duration", term: "Selected term (e.g., 10–30 years)", fe: "Generally permanent when policy requirements are met" },
  { feature: "Typical purpose", term: "Income, mortgage, debts, family protection", fe: "Funeral costs and final obligations" },
  { feature: "Typical benefit size", term: "Often larger", fe: "Usually smaller" },
  { feature: "Underwriting", term: "Varies by carrier and amount", fe: "Often simplified, depending on product" },
  { feature: "Cash value", term: "Generally none", fe: "May build cash value" },
  { feature: "Premium", term: "Depends on term length and policy", fe: "Often designed to remain level" },
];

export const CONSENT_TEXT =
  "By submitting this form, I authorize 1907 Insurance Group and Michael Janas to contact me about life insurance products and services at the phone number and email address I provided, including by phone call, text message, or email. I understand that my consent is not a condition of purchasing any goods or services.";

export const GENERAL_DISCLOSURE =
  "1907 Insurance Group is an independent insurance agency. Product availability, eligibility, rates, benefits, and underwriting requirements vary by insurance company, policy, applicant, and state. Information on this website is provided for general educational purposes and is not a guarantee of coverage or benefits. Coverage is not in force until an application has been approved by the issuing insurance company and all policy requirements have been satisfied.";

export const CARRIER_DISCLOSURE =
  "Carrier availability varies by state, product, applicant eligibility, and agent appointment. Not every product or carrier is available in every situation.";

export const PRODUCT_DISCLOSURE =
  "Product features, eligibility, coverage amounts, and benefits depend on the specific insurance carrier and policy. This page is for general education only.";

export const US_STATES = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD",
  "MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC",
  "SD","TN","TX","UT","VT","VA","WA","WV","WI","WY",
];

export const HEALTH_CONDITIONS = [
  "Heart disease or stroke",
  "Cancer (current or recent)",
  "Diabetes",
  "COPD or respiratory disease",
  "Kidney or liver disease",
  "Alzheimer's or dementia",
  "None of these",
];

export const LAUNCH_CHECKLIST = [
  "Confirm business hours and response-time wording",
  "Add a business mailing address (or remove the field)",
  "Confirm active carrier appointments and remove any carrier that cannot be verified",
  "Confirm each carrier logo is current and permitted for use",
  "Have consent language and legal pages reviewed by a qualified insurance compliance professional or attorney",
  "Verify quote, contact, and scheduling form emails arrive correctly",
  "Test tap-to-call links on a mobile phone",
  "Confirm no testimonials appear (none are published)",
  "Connect www.1907insurance.com as the custom domain",
  "Review analytics events — no health answers or personal values are sent to analytics",
];
